import { memo } from 'react'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { enqueueSnackbar } from 'notistack'
import ColumnOrderList from './ColumnOrderList'
import { ColumnOrderListType } from '../../redux/slices/entitySlice'

interface ColumnsArrangementPropsType {
    orgId: string
    templateId: string
    isAdmin: boolean
    isGuestUser: boolean
    columnsList: ColumnOrderListType[]
    handleUpdateColumnOrder: (updatedColumnList: ColumnOrderListType[]) => void
    handleSaveColumnOrder: () => void
    handleResetColumnOrder: () => void
    keywordForLocalStorage: string
    isRightSide?: boolean
}

const ColumnsArrangement: React.FC<ColumnsArrangementPropsType> = (props) => {
    const {
        orgId,
        templateId,
        isAdmin,
        isGuestUser,
        columnsList,
        handleResetColumnOrder,
        handleSaveColumnOrder,
        handleUpdateColumnOrder,
        keywordForLocalStorage,
        isRightSide = false,
    } = props
    const { t } = useTranslation()

    // save column re-order to local storage
    const saveColumnSettingsToLocalStorage = () => {
        localStorage.setItem(
            `${keywordForLocalStorage}ColumnsOrder_${isGuestUser ? 'guestOrg' : orgId}_${templateId}`,
            JSON.stringify(columnsList),
        )
        enqueueSnackbar(t('displayColumnsSavedSuccess'), {
            variant: 'success',
        })
    }

    //save the updated order
    const handleOnSaveList = () => {
        if (isAdmin) {
            handleSaveColumnOrder()
        } else {
            saveColumnSettingsToLocalStorage()
        }
    }

    //reset the order
    const handleOnResetList = () => {
        handleResetColumnOrder()
        enqueueSnackbar(t('displayColumnsResetSuccess'), {
            variant: 'success',
        })
    }

    return (
        <Box>
            <ColumnOrderList
                list={columnsList}
                handleUpdateList={handleUpdateColumnOrder}
                handleOnSaveList={() => handleOnSaveList()}
                handleOnResetList={() => handleOnResetList()}
                isRightSide={isRightSide}
            />
        </Box>
    )
}
const MemoizedColumnsArrangement = memo(ColumnsArrangement)
MemoizedColumnsArrangement.displayName = 'ColumnsArrangement'
export default MemoizedColumnsArrangement
